/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorModel } from './ErrorModel';
import { ProblemBadRequest } from './ProblemBadRequest';
import { ProblemBadRequestBlobEmptyData } from './ProblemBadRequestBlobEmptyData';
import { ProblemBadRequestBlobInvalidJson } from './ProblemBadRequestBlobInvalidJson';
import { ProblemBadRequestHasNullUnicodeCharacter } from './ProblemBadRequestHasNullUnicodeCharacter';
import { ProblemBadRequestPayloadTooLarge } from './ProblemBadRequestPayloadTooLarge';

export const BadRequestProblems: core.serialization.Schema<
    serializers.BadRequestProblems.Raw,
    Truvity.BadRequestProblems
> = core.serialization
    .union('type', {
        '/bad-request': ProblemBadRequest,
        '/bad-request/blob-empty-data': ProblemBadRequestBlobEmptyData,
        '/bad-request/blob-invalid-json': ProblemBadRequestBlobInvalidJson,
        '/bad-request/has-null-unicode-character': ProblemBadRequestHasNullUnicodeCharacter,
        '/bad-request/payload-too-large': ProblemBadRequestPayloadTooLarge,
        '/bad-request/validation': ErrorModel,
    })
    .transform<Truvity.BadRequestProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace BadRequestProblems {
    export type Raw =
        | BadRequestProblems.BadRequest
        | BadRequestProblems.BadRequestBlobEmptyData
        | BadRequestProblems.BadRequestBlobInvalidJson
        | BadRequestProblems.BadRequestHasNullUnicodeCharacter
        | BadRequestProblems.BadRequestPayloadTooLarge
        | BadRequestProblems.BadRequestValidation;

    export interface BadRequest extends ProblemBadRequest.Raw {
        type: '/bad-request';
    }

    export interface BadRequestBlobEmptyData extends ProblemBadRequestBlobEmptyData.Raw {
        type: '/bad-request/blob-empty-data';
    }

    export interface BadRequestBlobInvalidJson extends ProblemBadRequestBlobInvalidJson.Raw {
        type: '/bad-request/blob-invalid-json';
    }

    export interface BadRequestHasNullUnicodeCharacter extends ProblemBadRequestHasNullUnicodeCharacter.Raw {
        type: '/bad-request/has-null-unicode-character';
    }

    export interface BadRequestPayloadTooLarge extends ProblemBadRequestPayloadTooLarge.Raw {
        type: '/bad-request/payload-too-large';
    }

    export interface BadRequestValidation extends ErrorModel.Raw {
        type: '/bad-request/validation';
    }
}
